import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import Slideshow from "./Slideshow";
import TopSellers from "./TopSellers";
import AboutUs from "./AboutUs";
import Partners from "./Partners";

function HomePage() {
  return (
    <>
      <Header />

      <main className="homepage-content">
        <Slideshow />
        <TopSellers />
        <AboutUs />
        <Partners />
      </main>

      <Footer />

      <style>{`
        .homepage-content {
          min-height: 70vh;
          width: 100%;
          /* each section manages its own max-width and padding */
        }

        *, *::before, *::after {
          box-sizing: border-box;
        }
      `}</style>
    </>
  );
}

export default HomePage;